var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"local-estableshiment-filter"},[(_vm.isAdmin || _vm.isAnunciante)?[(_vm.hasEstableshimentFilter)?_c('local-filter',{attrs:{"data-entity":_vm.entity}}):_vm._e()]:_vm._e(),(_vm.isEstabelecimento && !_vm.isAdmin)?_c('local-filter',{attrs:{"data-entity":_vm.entity}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }